'use strict';
module.exports = require('./TabMenu.vue');